import React from "react";
import { IWarranty } from "../../../app/models/warranty";
import { Table, Header } from "semantic-ui-react";

interface IProps {
  warranty: IWarranty;
}

const WarrantyDetails: React.FC<IProps> = ({ warranty }) => {
  return (
    <Table celled striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan="2">Warrant Details</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              First Name
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_firstname}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Last Name
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_lastname}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Address Line 1
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_address}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Address Line 2
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_address1}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Suburb
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_suburb}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              State
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_state}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Postcode
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_postcode === 0 ? '' : warranty.warranty_postcode}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Contact Number
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_contact_number}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Email
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_email}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
            Category
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_category}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              SKU
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_sku}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Barcode
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_barcode}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Purchased On
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_purchased_dateDisplay}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Created On
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_createdAtDisplay}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Period
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_new_warranty_period} Months</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              End Date
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_warranty_end_dateDisplay}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Header as="h4" textAlign="left">
              Order No
            </Header>
          </Table.Cell>
          <Table.Cell>{warranty.warranty_order_no}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export default WarrantyDetails;
